module.exports = __webpack_public_path__ + "static/media/vitukraina_01.9750dbd8.png";